import { render, staticRenderFns } from "./Nacionalidade.vue?vue&type=template&id=6f987485&scoped=true&"
import script from "./Nacionalidade.vue?vue&type=script&lang=js&"
export * from "./Nacionalidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f987485",
  null
  
)

export default component.exports